<template>
    <div>
    <div id="footer" class="footer fixed-bottom icoWorkSpace w-100 ml-0 mr-0 d-flex justify-content-center">
            <div v-if="$i18n.locale==='sk'" class="flagExtern setLang mt-1 mb-1 " >
                <img src="img/sk.svg" alt="" class="flag" />
            </div>        
            <!--Prepnúť jazykovú verziu obsahu - slovenský jazyk-->
            <div v-else class="flagExtern setLang mt-1 mb-1 lang-title" >
                <img @click="changeLanguage('sk')" src="img/sk.svg" alt="" class="flag-off" />
                <span class="tooltip-text">{{ $t('footer.1') }}</span>
            </div>  

            <div v-if="$i18n.locale==='en'" class="flagExtern setLang mt-1 mb-1 " >
                <img  src="img/en.svg" alt="" class="flag" />
            </div>
            <!--Prepnúť jazykovú verziu obsahu - anglický jazyk-->
            <div v-else class="flagExtern setLang mt-1 mb-1 lang-title" >
                <img  @click="changeLanguage('en')" src="img/en.svg" alt="" class="flag-off" />
                <span class="tooltip-text">{{ $t('footer.2') }}</span>
            </div>

            <div v-if="$i18n.locale==='de'" class="flagExtern setLang mt-1 mb-1 " >
                <img src="img/de.svg" alt="" class="flag" />
            </div>
            <!--Prepnúť jazykovú verziu obsahu - nemecký jazyk-->
            <div v-else class="flagExtern setLang mt-1 mb-1 lang-title" >
                <img  @click="changeLanguage('de')" src="img/de.svg" alt="" class="flag-off" />
                <span class="tooltip-text">{{ $t('footer.3') }}</span>
            </div>
            
            <div class="flagExtern-off setLang mt-1 mb-1 " />

            <!--Profil osoby z tohto životopisu v rámci sociálnej siete Facebook-->
            <div class="icoExtern facebook mt-1 mb-1 " >
                <a  target="parent" href="https://www.facebook.com/rastislav.rehak1/">
                    <i class="fab fa-facebook-square"></i>
                </a>
                <span class="tooltip-text">{{ $t('footer.5') }}</span>
            </div>

            <!--Stiahnuť tento životopis v podpísanom formáte PDF a v nastavenom jazyku-->
            <div class="adobeAcro icoExtern mt-1 mb-1 " >
                <a  target="parent" class="adobeAcrobatHref" :href="'https://abnet.sk/' + $i18n.locale + '.pdf'">
                    <i class="fas fa-file-pdf"></i>
                </a>
                <span class="tooltip-text">{{ $t('footer.4') }}</span>
            </div>        

            <div class="download icoExtern mt-1 mb-1 " >
                <a  target="parent" class="adobeAcrobatHref" href="https://abnet.sk/android.zip">
                    <i class="fas fa-mobile-alt"></i>
                </a>
                <span class="tooltip-text">{{ $t('footer.7') }}</span>
            </div>        

            <div class="download icoExtern mt-1 mb-1 ">
                <a  target="parent" class="adobeAcrobatHref" href="https://abnet.sk/cv_rastislav_rehak.zip">
                    <i class="fas fa-download"></i>
                </a>
                <span class="tooltip-text">{{ $t('footer.6') }}</span>
            </div>        


            
            <!--==-->
            

            <!--
            < !--Zdrojový kód tohto životopisu (VUE JS 3)-- >
            <div style="" class="openGithub icoExtern mt-1 mb-1 " :data-title="$t('footer.3')">
                <a  target="parent" href="https://github.com/russell1969Din/_________A_ABNet.sk-new">
                    <i class="fab fa-github-square"></i>
                </a>
            </div>        

            < !--Profil osoby z tohto životopisu v rámci sociálnej siete Facebook-- >
            <div style="" class="icoExtern facebook mt-1 mb-1 " :data-title="$t('footer.4')">
                <a  target="parent" href="https://www.facebook.com/rastislav.rehak1/">
                    <i class="fab fa-facebook-square"></i>
                </a>
            </div>
            
            < !--Profil osoby z tohto životopisu v rámci sociálnej siete LinkedIn-- >
            <div style="" class="icoExtern linkedIn mt-1 mb-1 " :data-title="$t('footer.5')">
                <a  target="parent" href="https://www.linkedin.com/in/rastislav-rehák-a14b191b6/">
                    <i class="fab fa-linkedin"></i>
                </a>
            </div>        
            -->

            <!---
            <div style="" class="icoExtern downloadZIP download mt-1 mb-1 " data-title="">
                <a  target="parent" href="/download/demo.zip" >
                    <i class="fas fa-download"></i>
                </a>
            </div>        
            -->
     </div>
    </div>
</template>

<script>
    export default {
        methods: {
            changeLanguage(param) {

                this.$i18n.locale = param

                /*
                if(this.$i18n.locale == 'sk' && !solved )   {
                    solved = true
                    this.$i18n.locale = 'en'
                }
                if(this.$i18n.locale == 'en' && !solved)   {
                    solved = true
                    this.$i18n.locale = 'sk'
                }
                    */
            }
        },
    }
</script>

<style lang="scss" scoped>

.icoExtern,
.setLang {
  position: relative;
  display: inline-block;
  overflow: visible;

  .tooltip-text {
    position: absolute;
    bottom: 140%;
    left: 50%;
    transform: translateX(-50%);
    //background: rgba(0, 0, 0, 0.85);
    background: #0091cc;
    color: #fff;
    padding: 6px 10px;
    border-radius: 6px;
    font-size: 0.8rem;
    line-height: 1.3;
    text-align: center;
    width: 120px;      // fixná šírka pre 2 riadky
    white-space: normal;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.2s ease;
    z-index: 9999;
  }

  &:hover .tooltip-text,
  &:focus .tooltip-text,
  &:active .tooltip-text {
    opacity: 1;
  }

  // malý trojuholník
  &:hover::before,
  &:focus::before,
  &:active::before {
    content: '';
    position: absolute;
    bottom: 130%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: #0091cc transparent transparent transparent;
    opacity: 1;
    z-index: 9998;
  }
}

</style>